'use client'
import * as React from 'react'
import { useUserData } from '~/hooks-data/use-user-data'
import { LabeledCheckbox } from '~/sotano-kit/primitives/checkbox'
import { setReleaseNotePreference } from './server'
import debounce from 'lodash.debounce'

export const Preferences = () => {
  const user = useUserData(null)
  const [showReleaseNoteAfterUpdate, setShowReleaseNoteAfterUpdate] =
    React.useState(false)
  const [hasSynced, setHasSynced] = React.useState(false)

  React.useEffect(() => {
    if (!user.data) return
    setShowReleaseNoteAfterUpdate(user.data.showReleaseNote)
    setHasSynced(true)
  }, [user.data])

  // eslint-disable-next-line react-compiler/react-compiler
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const updateUserPreferences = React.useCallback(
    debounce(setReleaseNotePreference, 1000),
    []
  )

  React.useEffect(() => {
    if (!hasSynced || !user.data?.id) return
    updateUserPreferences({
      userId: user.data.id,
      showReleaseNote: showReleaseNoteAfterUpdate,
    })
  }, [
    hasSynced,
    showReleaseNoteAfterUpdate,
    updateUserPreferences,
    user.data?.id,
  ])

  return (
    <LabeledCheckbox
      size="xs"
      className="[&>span]:!min-w-0 [&>span]:leading-tight [&>span]:text-pretty !items-start text-dark-dim"
      horizontal="reverse"
      label={<span>Show release notes after an update</span>}
      name="release-note-after-update"
      checkboxProps={{
        className: '!size-[15px]',
        checked: showReleaseNoteAfterUpdate,
        onCheckedChange: (value) => {
          if (value === 'indeterminate') return
          setShowReleaseNoteAfterUpdate(value)
        },
      }}
    />
  )
}
